import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { URLsConfig } from '../URLsConfig';
import { TreatmentGroupHDDetModel } from '../models/TreatmentGroupHDDetModel';
import { TreatmentGroupHDService } from './TreatmentGroupHDService';
@Injectable({
  providedIn: 'root'
})
export class TreatmentGroupDetService {

  constructor(private http: HttpClient, public urlsconfig: URLsConfig) { }

   public GetTreatmentGroupDet(tgcode: string , compcode: string) {
    
    let params = new HttpParams();
    params = params.append("tgcode",tgcode );
    params = params.append("compcode", compcode);
    const options = {
                params: params
            };
            return this.http.get<TreatmentGroupHDDetModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/TreatmentGroupDet/GetTreatmentGroupDet',options);
        }
        public AddTreatmentGroupDet(treatmentgroupdet :TreatmentGroupHDDetModel) {

        return this.http.post<TreatmentGroupHDDetModel>(this.urlsconfig.WebAPIURL_Test + 'api/TreatmentGroupDet/AddTreatmentGroupDet', treatmentgroupdet);

        }

         public deleteTreatmentGroupDet(tgcode: string,prDetItCode : string) {
        let params = new HttpParams();
        params = params.append("tgcode", tgcode);
        params = params.append("tgDetItCode", prDetItCode);
        const options = {
            params: params
        };


        return this.http.get<TreatmentGroupHDDetModel>(this.urlsconfig.WebAPIURL_Test + 'api/TreatmentGroupDet/DeleteTreatmentGroupDet', options);
      }





}
